import declare from "dojo/_base/declare";
import _WidgetBase from "dijit/_WidgetBase";
import AttributeCard from "csi/card/AttributeCard";
import ToolbarPlugin from "csi/view/ToolbarPlugin";
import html from "csi/html";
import csiCard from "csi/card/_base";

const ToolbarAttributeCard = declare([_WidgetBase, ToolbarPlugin], {
	class: "csi-toolbar-attribute-card",

	/**
	 * @override
	 * Watch for changes to context
	 */
	postCreate() {
		this.inherited(arguments);
		this.getView().watch("urlRoot", () => this.onChangeNode());
		this.onChangeNode();
	},

	/**
	 * Recreate attribute card
	 */
	onChangeNode() {
		const { domNode } = this;
		const view = this.getView();
		const ctx = view.getContext(view.urlRoot);
		const node = ctx.getNode();

		html.destroyChildren(domNode);

		if (node) {
			const params = csiCard.getAttributeCardSpecs(node.$Type);

			new AttributeCard({
				ctx,
				...params,
			}).placeAt(domNode);
		}
	},
});

export = ToolbarAttributeCard;